/**
 * Gestion menu navbar + header
 */
export function handleNav() {
  // navbar toggler
  const toggleNav = function () {
    this.classList.toggle('open')
  }
  const h = document.getElementById('header')
  h.querySelector('.nav-icon').addEventListener('click', toggleNav)
}

/**
 * Sticky header
 */
// var lastScrollTop = 0
export function sticky() {
  const h = document.getElementById('header'),
    s = 'sticky',
    b = document.body,
    w = document.querySelector('html'),
    bp = 1399 - 40
  //console.log('window.scrollY', window.scrollY)
  //console.log('document.body', document.querySelector('html').scrollTop)
  //console.log('h.offsetTop', h.offsetTop)
  // if ((w.scrollTop > 115 && w.offsetWidth > bp) || (w.scrollTop > 80 && w.offsetWidth <= bp))
  if (w.scrollTop > 150) {
    h.classList.add(s)
    if (h.classList.contains('home-header'))
      h.classList.remove('navbar-transparent')
  } else {
    if (h.classList.contains('home-header'))
      h.classList.add('navbar-transparent')
    h.classList.remove(s)
  }
}